import React, { useState, useEffect } from "react"
import Card from "../Components/Card"
import firebase from "../firebase"

const Work = () => {
  const [projects, setProjects] = useState([])

  const [viewMore, setviewMore] = useState(3)

  useEffect(() => {
    const projectRef = firebase.database().ref("Projects")
    projectRef.on("value", (snapshot) => {
      const projectList = []
      const project = snapshot.val()
      for (let id in project) {
        projectList.push(project[id])
      }
      setProjects(projectList)
    })
  }, [])

  return (
    <section id="work">
      <div className="container pb-5">
        <div className="row py-3 text-center">
          <div className="col-12">
            <h1 className="sectionname">My work</h1>
            <hr className="mx-auto" />
          </div>
        </div>
        <div className="row py-3 mx-auto justify-content-center">
          {projects.slice(0, viewMore).map((project, index) => {
            return (
              <Card
                key={index}
                title={project.title}
                desc={project.description}
                imgid={project.imgid}
                sourceUrl={project.sourceUrl}
              />
            )
          })}
        </div>
        {viewMore < projects.length && (
          <div className="text-center">
            <button
              className="btn btn-outline-primary more"
              onClick={() => {
                setviewMore((prev) => {
                  return prev + 2
                })
              }}>
              View More
            </button>
          </div>
        )}
        {viewMore >= projects.length && (
          <div className="text-center">
            <button
              className="btn btn-outline-primary more"
              onClick={() => setviewMore(3)}>
              Show Less
            </button>
          </div>
        )}
      </div>
    </section>
  )
}

export default Work
